module.exports = __webpack_public_path__ + "static/odofin-448f9cad9505f1bff7b7524a31801bc9.png";